var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.68 7.85c.95-1.59 3.63-5.1 8.6-5.1 4.99 0 7.66 3.51 8.62 5.1.42.71.42 1.59 0 2.3-.96 1.59-3.63 5.1-8.61 5.1-4.98 0-7.66-3.51-8.61-5.1a2.22 2.22 0 0 1 0-2.3Zm8.6-3.6c-4.17 0-6.45 2.94-7.32 4.37a.72.72 0 0 0 0 .76c.87 1.43 3.15 4.37 7.33 4.37s6.46-2.94 7.32-4.37a.72.72 0 0 0 0-.76c-.86-1.43-3.14-4.37-7.32-4.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.25 6.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm-4 2.5a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "accent",
    d: "M16.78 1.47c.3.3.3.77 0 1.06l-14 14a.75.75 0 0 1-1.06-1.06l14-14c.3-.3.77-.3 1.06 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eyeClosed.6c1709bd00363efc3e530f3065966741.svg";
export { ForwardRef as ReactComponent };